<template>
    <section>
        <div v-show="videos.length" class="video-box df jcsb">
            <router-link v-for="v in videos" :key="v.id" :to="`/videos/${v.id}`" class="video-link">
                <div class="video-thumb" :style="`background-image: url(${v.thumb})`">
                    <div class="video-meta">
                        <div class="video-meta-play">
                            <i class="icon-play"></i>{{$view(v.views)}}
                        </div>
                        <i class="icon-time"></i>{{$date(v.addtime)}}
                    </div>
                </div>
                <div class="video-title">{{v.title}}</div>
            </router-link>
        </div>
        <div v-show="isLoading" class="loading-box"><div class="loading"></div></div>
        <div v-show="!isLoading && !videos.length" class="empty">暂时没有视频(～￣▽￣)～</div>
        <a v-if="!isLoading && videos.length" class="empty download" href="http://a.app.qq.com/o/simple.jsp?pkgname=com.vhiphop.app">查看全部视频，请下载 Vhiphop 客户端 &gt;&gt;</a>
    </section>
</template>

<script>
    export default {
        props: {
            dancer: String,
            avatar: String,
        },
        data: () => ({
            videos: [],
            isLoading: true,
        }),
        computed: {
            id() {
                return +this.$route.params.id || 0;
            },
        },
        async beforeMount() {
            this.videos = await this.api.get(`dancers/${this.id}/videos`).catch(this.err);
            this.isLoading = false;
            this.$share(this.dancer, this.avatar);
        },
    }
</script>

<style scoped>
    @import '../../../static/css/home/video-list.css';
</style>


// WEBPACK FOOTER //
// src/components/dancer/Video.vue